import type {
    VerifyCommerceCustomerCodeRequest,
    VerifyCommerceCustomerCodeResponse,
} from "@teqtank/commerce-contracts";
import { defineCommerceOperation } from "@teqtank/commerce-transport";
export const verifyCommerceCustomerCodeOperation = defineCommerceOperation<
    VerifyCommerceCustomerCodeRequest,
    VerifyCommerceCustomerCodeResponse
>("commerce.customer.verification-code.verify");
